export default __webpack_public_path__ + "static/media/goshen36.83470be5.jpg";